/**
 * One condition on a rule/line — a key ("Only on", "Exception on", "Only when")
 * and the engine-owned values it holds for, optionally with a trailing note.
 */
export type Condition = {
  key: string
  values: string[]
  note?: string
}

/**
 * The shared display of what gates a davening onto a sheet — used BOTH by the
 * rules cards and by the luach's logic view, so the styling and structure live
 * in exactly one place. Values are shown in the accent; the caller supplies the
 * already-computed, engine-labeled conditions.
 */
export function Conditions({ conditions }: { conditions: Condition[] }) {
  const shown = conditions.filter((c) => c.values.length)
  if (!shown.length) return null
  return (
    <div className="conditions">
      {shown.map((c) => (
        <span className="cond" key={c.key}>
          <span className="cond__key">{c.key}</span>
          <span className="cond__val">{c.values.join(' · ')}</span>
          {c.note ? <span className="cond__note"> — {c.note}</span> : null}
        </span>
      ))}
    </div>
  )
}
